import classnames from 'classnames/bind'
import React from 'react'

import ImageWithPlaceholder, {
  ImageWithPlaceholderProps,
} from '~/components/ImageWithPlaceholder'

import { useStyle } from '~/providers/StyleProvider'

import Ratio from '../Ratio'
import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ArticleImageProps {
  className?: string
  image?: ImageWithPlaceholderProps
  layout?: 'small' | 'big'
}

const RATIO = {
  big: 1377 / 822,
  small: 960 / 607,
}

function ArticleImage({ className, image, layout }: ArticleImageProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })

  return (
    <section className={cx(css.ArticleImage, className, layout)}>
      <div className={cx(gridStyle, css.grid)}>
        {image && (
          <Ratio className={css.image} ratio={RATIO[layout]}>
            {(cn) => (
              <ImageWithPlaceholder
                layout="fill"
                objectFit="cover"
                {...image}
              />
            )}
          </Ratio>
        )}
      </div>
    </section>
  )
}

ArticleImage.defaultProps = {}

export default ArticleImage
